import * as authRoutes from './auth';
import ForgotPasswordContainer from '../containers/ForgotPasswordContainer';
import LoginContainer from '../containers/LoginContainer';
import RegisterContainer from '../containers/RegisterContainer';
import ResetPasswordContainer from '../containers/ResetPasswordContainer';
export const AuthRoutes = [
  {
    key: 'login',
    exact: true,
    path: authRoutes.LOGIN,
    component: LoginContainer
  },
  {
    key: 'register',
    exact: true,
    path: authRoutes.REGISTER,
    component: RegisterContainer
  },
  {
    key: 'forgot-password',
    exact: true,
    path: authRoutes.FORGOT_PASSWORD,
    component: ForgotPasswordContainer
  },
  {
    key: 'reset-password',
    exact: true,
    path: authRoutes.RESET_PASSWORD,
    component: ResetPasswordContainer
  }
];
